import { Injectable, ApplicationRef, ComponentRef, createComponent } from '@angular/core';
import { AlertComponent } from './alert/alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private currentAlert?: ComponentRef<AlertComponent>;
  private currentSubscription?: any;

  constructor(private appRef: ApplicationRef) {}

  show(options: {
    title: string;
    description?: string;
    type?: 'success' | 'error' | 'info' | 'warning' | 'cart';
    duration?: number;
    thumbnailUrl?: string;
  }) {
    // Remove any existing alert
    this.clear();

    // Create the component
    const componentRef = createComponent(AlertComponent, {
      environmentInjector: this.appRef.injector
    });

    // Set the inputs
    Object.assign(componentRef.instance, options);

    // Add to the DOM
    document.body.appendChild(componentRef.location.nativeElement);

    // Attach to the change detection and store reference
    this.appRef.attachView(componentRef.hostView);
    this.currentAlert = componentRef;

    // Force change detection
    componentRef.changeDetectorRef.detectChanges();

    // Store and manage subscription
    this.currentSubscription = componentRef.instance.visibilityChange$.subscribe((visible: any) => {
      if (!visible) {
        setTimeout(() => {
          this.clear();
        }, 200); // Wait for animation to complete
      }
    });

    return componentRef;
  }

  clear() {
    if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
      this.currentSubscription = undefined;
    }
    if (this.currentAlert) {
      this.appRef.detachView(this.currentAlert.hostView);
      this.currentAlert.destroy();
      this.currentAlert = undefined;
    }
  }
}
